<template>
  <div :aria-labelledby="id+'-title'"
       :id="id"
       aria-hidden="true"
       class="modal fade"
       role="dialog"
       tabindex="-1">
      
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-dialog-centered-custom modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-body-scrolled pb-0">
          <h5 :id="id+'-title'" class="modal-title mb-2">{{ title }}</h5>
        </div>
        <div class="modal-body">
          <p class="pl-2" v-html="comments"></p>
        </div>
        <div class="modal-footer shadow-none">
          <button class="btn btn-light" data-dismiss="modal" type="button">Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CommentsModal',
    props: {
      id: {
        default: 'comments-modal',
      },
      title: {
        default: 'Comentarios',
      },
      comments: {
        type: String,
        default: '',
      }
    },
    methods: {
      open() {
        $(this.$el).modal('show')
      },
      close() {
        $(this.$el).modal('hide')
      }
    }
  }
</script>
